import React, {useEffect} from 'react';
import Portfolio from '../portfolio';
import Loading from '../../../shared/portfolio/components/loading';
import {fetchPortfolioInfo, receivePortfolioInfo} from 'shared/portfolio/actions/portfolio';
import {useDispatch, useSelector} from 'react-redux';
import {Store} from 'src/types/store';

const RoutedPortfolio = () => {
  const dispatch = useDispatch();
  const portfolioInitiated = useSelector((state: Store) => state.portfolioInitiated);

  const initiatePortfolio = () => {
    // this one is not a thunk, we can refactor
    // it once the non-routed portfolio is deprecated
    fetchPortfolioInfo().then((portfolioInfo) => {
      dispatch(receivePortfolioInfo(portfolioInfo));
    });
  };

  useEffect(() => {
    if (!portfolioInitiated) {
      initiatePortfolio();
    }
  }, [portfolioInitiated]);

  if (!portfolioInitiated) {
    return <Loading />;
  }

  return <Portfolio />;
};

export default RoutedPortfolio;
